export default "__VITE_ASSET__CeJbtwtl__"